module.exports = {
  mode: 'production',
  apiUrl: 'https://aapi.wannasport.com/api',
  wsApiUrl: 'https://wsapi.wannasport.com/api',
  googleApiKey: 'AIzaSyCLD2uFG50T64oy6lRXv7RkUGG97OST9zM',
  googleLoginClientId: '485318900050-7qmoe5bjrfr8rpocpra4532sclbmiahf.apps.googleusercontent.com',
  intercomAppId: 'xe9ttx0v',
  adyen: {
    domain: 'ca-live.adyen.com'
  }
};